module.exports = __webpack_public_path__ + "static/media/blog4.0377ce48.png";